import React from 'react';
import styles from './SocialIcons.module.css';
import { handleShare } from '../utils/socialUtils';

// Importando ícones do Material UI
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

/**
 * Componente de ícones de redes sociais para o footer
 * Inclui Instagram, Facebook, Compartilhar e Indicar um amigo
 */
function SocialIcons() {
  return (
    <div className={styles.socialIcons}>
      {/* Instagram */}
      <a
        href="https://www.instagram.com/gabriela.app.br/"
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.socialIcon} ${styles.instagram}`}
        aria-label="Siga-nos no Instagram"
        title="Siga-nos no Instagram"
      >
        <InstagramIcon />
      </a>

      {/* Facebook */}
      <a
        href="https://www.facebook.com/profile.php?id=61579111109887"
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.socialIcon} ${styles.facebook}`}
        aria-label="Siga-nos no Facebook"
        title="Siga-nos no Facebook"
      >
        <FacebookIcon />
      </a>

      {/* Compartilhar */}
      <button
        onClick={handleShare}
        className={`${styles.socialIcon} ${styles.share}`}
        aria-label="Compartilhar Gabriela"
        title="Compartilhar Gabriela"
        type="button"
      >
        <ShareOutlinedIcon />
      </button>
    </div>
  );
}

export default SocialIcons;